<template>
  <div
    v-if="!hideEverything"
    class="product-clickout-view"
  >
    <div
      v-if="!loading && hasRealData && !outclickAlerts.length && !hasOrderInstructions"
      class="loader-container-container"
    >
      <div class="loader-container">
        <div class="animated-redirect">
          <div class="animated-clickout-loader">
            <div class="curve" />
            <div class="ball-container">
              <div class="ball" />
            </div>
          </div>
          <div class="product-logos">
            <div class="logo-from">
              <img
                :src="keuzeLogo"
                alt="Keuze logo"
              >
            </div>
            <div class="logo-to">
              <img
                :src="product.provider_logo"
                :alt="product.provider_name"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="subtext">
        We sturen je naar de juiste bestelpagina van <strong>{{ product.provider_name }}</strong>
        <br>
        <template v-if="product.show_legacy">
          <div class="new-tax-notice">
            In 2021 verandert de energiebelasting<span class="tax-difference"> (<template
              v-if="product.legacy_month - product.month_price_without_discount > 0"
            >+</template> {{
              toCurrencyEur(product.legacy_month - product.month_price_without_discount)
            }} per maand)</span>.<br>
            Bij {{ product.provider_name }} zie je het nieuwe bedrag van <strong>&euro;&nbsp;<template
              v-if="product.tariffs_with_discount"
            >{{ toCurrency(product.legacy_month_discount) }}
            </template>
              <template v-else>{{ toCurrency(product.legacy_month) }}</template>
              p/m</strong>
            <template v-if="!product.tariffs_with_discount">
              (zonder korting)
            </template>
            .
          </div>
        </template>
        <div class="outlink-container">
          <a
            :href="signupURL"
            class="outlink"
            rel="nofollow"
          >Klik hier als je niet doorgestuurd wordt</a>
          <span
            class="loader-line"
            :style="'width: '+ timeLeftPercentage + '%'"
          />
        </div>
      </div>
    </div>

    <div v-if="!loading && !hasRealData">
      <div class="loader-container">
        <div class="animated-redirect">
          <div class="animated-clickout-loader">
            <div class="curve" />
            <div class="ball-container">
              <div class="ball" />
            </div>
          </div>
          <div class="product-logos">
            <div class="logo-from">
              <img
                :src="keuzeLogo"
                alt="Keuze logo"
              >
            </div>
            <div class="logo-to">
              <!-- None... -->
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="!hasOrderInstructions"
        class="subtext"
      >
        We sturen je naar de juiste bestelpagina
        <br>
        <a
          :href="signupURL"
          class="outlink"
          rel="nofollow"
          target="_self"
        >Klik hier als je niet doorgestuurd wordt</a>
      </div>
    </div>

    <div
      v-if="!loading && hasRealData && outclickAlerts.length && !hasOrderInstructions"
      class="outclick-content"
    >
      <div class="loader-container">
        <div class="animated-redirect">
          <div class="animated-clickout-loader">
            <div class="curve" />
            <div class="ball-container">
              <div class="ball" />
            </div>
          </div>
          <div class="product-logos">
            <div class="logo-from">
              <img
                :src="keuzeLogo"
                alt="Keuze logo"
              >
            </div>
            <div class="logo-to">
              <img
                :src="product.provider_logo"
                :alt="product.provider_name"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="subtext">
        <div class="introtext">
          <span class="intro-pre-text">Over het bonnetje van</span>
          <strong class="intro-provider-text">{{ product.provider_name }}</strong>
        </div>
        <div class="outclick-container">
          <div
            v-for="outclickAlert in outclickAlerts"
            class="outclick-block-container"
          >
            <div class="outclick-block">
              <icon
                icon="x-fa-info-circle"
                size="l"
              />
              <span v-html="outclickAlert.message" />
            </div>
          </div>
        </div>

        <a
          v-if="blockForwarding"
          :href="signupURL"
          role="button"
          class="link primary"
          rel="nofollow"
        >
          <span>Naar {{ product.provider_name }}</span>
          <span><icon
            icon="x-fa-long-arrow-right"
            size="m"
          /></span>
        </a>
        <div
          v-if="!blockForwarding"
          class="outclick-clickthrough outlink-container"
        >
          <strong class="clickthrough-text">We sturen je door</strong>
          <a
            :href="signupURL"
            class="outlink"
            rel="nofollow"
            target="_self"
          >Klik hier als je niet wordt
            doorgestuurd</a>
          <span
            class="loader-line"
            :style="'width: '+ timeLeftPercentage + '%'"
          />
        </div>
      </div>
    </div>

    <div
      v-if="!loading && hasRealData && hasOrderInstructions"
      class="outclick-content"
    >
      <div class="loader-container">
        <div class="animated-redirect">
          <div class="animated-clickout-loader">
            <div class="curve" />
            <div class="ball-container">
              <div class="ball" />
            </div>
          </div>
          <div class="product-logos">
            <div class="logo-from">
              <img
                :src="keuzeLogo"
                alt="Keuze logo"
              >
            </div>
            <div class="logo-to">
              <img
                :src="product.provider_logo"
                :alt="product.provider_name"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="subtext">
        <div class="introtext">
          <span class="intro-pre-text">Dit contract is helaas niet online af te sluiten bij</span>
          <strong class="intro-provider-text">{{ product.provider_name }}</strong>
        </div>
        <div class="outclick-container">
          <div class="outclick-block-container">
            <div class="outclick-block">
              <icon
                icon="x-fa-info-circle"
                size="l"
              />
              <span
                v-if="product"
                v-html="product.order_instructions"
              />
            </div>
            <div class="outclick-block">
              <icon
                icon="x-fa-info-circle"
                size="l"
              />
              <span>Je kunt dit tabblad afsluiten als je klaar bent of als je terug wilt naar de vergelijker.</span>
            </div>
          </div>
        </div>
        <br>
      </div>
    </div>

    <div>
      <span
        class="loader-line-full"
        :style="'opacity: '+(timeLeftPercentageGradient*-1+100)+'%'"
      />
      <span
        :class="'loader-line-full-sec provider-'+slug"
        :style="'opacity: '+(timeLeftPercentageGradient)+'%'"
      />
    </div>
  </div>
  <!--  Fallback view (no session data/incognito basic loader) -->
  <div
    v-else
    class="product-clickout-view"
  >
    <div class="loader-container">
      <div class="animated-redirect">
        <div class="animated-clickout-loader">
          <div class="curve" />
          <div class="ball-container">
            <div class="ball" />
          </div>
        </div>
        <div class="">
          <div class="">
            <img
              :src="keuzeLogo"
              alt="Keuze logo"
              width="180"
            >
          </div>
          <div class="logo-to">
            <!-- None... -->
          </div>
        </div>
      </div>
    </div>
    <div>
      <span
        class="loader-line-full"
        :style="'opacity: '+(timeLeftPercentageGradient*-1+100)+'%'"
      />
      <span
        :class="'loader-line-full-sec provider-'+slug"
        :style="'opacity: '+(timeLeftPercentageGradient)+'%'"
      />
    </div>
  </div>
</template>

<script>
import Icon from 'vue-elements/icon/Icon.vue';

export default {
    components: { Icon },
    props: ['productID'],

    data() {
        return {
            loading: true,
            product: null,
            hasRealData: false,
            hideEverything: true,
            outclickAlerts: [],
            blockForwarding: false,

            redirectTimeout: 3,
            redirectionTimer: null,
            timeLeft: 0,

            signupURL: '',
            slug: '',
        };
    },

    computed: {
        keuzeLogo() {
            return '/assets/keuze/keuze-logo.svg';
        },
        timeLeftPercentage() {
            return 100 - Math.round((this.timeLeft / this.redirectTimeout) * 100);
        },
        timeLeftPercentageGradient() {
            return (100 - Math.round((this.timeLeft / this.redirectTimeout) * 100));
        },

        conversionValue() {
            if (this.product) {
                return this.product.cval;
            }
            return 1;
        },

        hasOrderInstructions() {
            return typeof this.product !== 'undefined' && this.product !== null && typeof this.product.order_instructions !== 'undefined' && this.product.order_instructions !== null;
        },
    },
    created() {
        this.$emit('startPhase', 'outclick');
    },

    mounted() {
        window.setInterval(() => {
            this.createSignupURL();
        }, 300);

        this.timeLeft = this.redirectTimeout;
        if (typeof Storage !== 'undefined') {
            // Load product from local storage:
            const productDataKey = 'productdata-energy';
            const productData = JSON.parse(window.localStorage.getItem(productDataKey));

            if (productData !== null && productData.hasOwnProperty(this.productID)) {
                this.product = productData[this.productID];
                this.outclickAlerts = this.product.outclick_alerts;
                this.blockForwarding = this.product.block_forwarding;
                this.slug = this.product.provider.replace(/-/, '');

                this.redirectTimeout += (this.outclickAlerts.length * 2);
                this.hasRealData = true;
                this.loading = false;

                if (this.hasRealData && this.product.available_orderline) {
                    // Redirect immediately
                    window.location = this.product.signup_url;
                    this.hideEverything = true;
                } else {
                    document.body.classList.add('show-everything');
                    this.hideEverything = false;
                }

                if (!this.blockForwarding) {
                    this.startRedirect();
                }
                return;
            }
        }

        // Fallback data
        // TODO: load real signup via AJAX
        this.hasRealData = false;
        this.loading = false;
        this.startRedirect();
    },
    methods: {
        startRedirect() {
            if (this.hasOrderInstructions) {
                return;
            }

            if (!this.loading) {
                this.trackClickOut();

                if (this.redirectionTimer !== null) {
                    window.clearTimeout(this.redirectionTimer);
                }
                if (this.hasRealData) {
                    if (this.product.show_legacy) {
                        this.redirectTimeout = 9;
                    }
                } else {
                    this.redirectTimeout = 3;
                }

                window.setTimeout(() => {
                    window.location = this.signupURL;
                }, (this.redirectTimeout * 1000) + 1000);

                this.startCountDown();
            }
        },
        startCountDown() {
            this.timeLeft = this.redirectTimeout;
            window.setInterval(() => {
                if (this.timeLeft > 0) {
                    this.timeLeft -= 1;
                }

                if (this.timeLeft < 0) {
                    this.timeLeft = 0;
                }
            }, 1000);
        },
        trackClickOut() {
            const clickOutEventData = {
                product_id: this.productID,
                conversion_value: this.conversionValue,
            };

            if (this.hasRealData) {
                clickOutEventData.provider_name = this.product.provider_name;
                clickOutEventData.rank = this.product.rank;
            }

            this.logAnalyticsEvent('compare-energy.outclick-screen', clickOutEventData);
        },

        createSignupURL() {
            if (this.hasRealData) {
                this.signupURL = this.product.signup_url;
            } else {
                let url = `https://api-energie.keuze.nl/v1/click/yZv4mJs9qTfWcQz6-554/${this.productID}/signup?`;

                if (this.$attrs.urlNumber && this.$attrs.urlPostcode) {
                    url += `pc=${this.$attrs.urlPostcode}&nr=${this.$attrs.urlNumber}`;
                }

                url = `${url}&tracking=${window.global_tracking}`;

                this.signupURL = url;
            }
        },
    },
};
</script>

<style lang="scss">
.loader-container-container {
  padding-left: 12px;
  padding-right: 12px;
}
</style>
